import { render, staticRenderFns } from "./TemplateProximos.vue?vue&type=template&id=fa8a6a96&scoped=true&"
import script from "./TemplateProximos.vue?vue&type=script&lang=js&"
export * from "./TemplateProximos.vue?vue&type=script&lang=js&"
import style0 from "./TemplateProximos.vue?vue&type=style&index=0&id=fa8a6a96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8a6a96",
  null
  
)

export default component.exports